import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const MarketingCampaigns = () => {
    const navigate = useNavigate();

    const handleGoToEditor = useCallback(() => {
        navigate('/campaigns/marketing/email-editor');
    }, [navigate]);

    return (
        <div>
            <h1>Marketing Campaigns</h1>
            <Button onClick={handleGoToEditor}>{getLiteral('label_design')}</Button>
        </div>
    );
};

export default MarketingCampaigns;
